import {
  MODIFY_USER_FAIL,
  MODIFY_USER_REQUEST,
  MODIFY_USER_SUCCESS,
} from '../constants/userConstants';
import { notifyFromErrorConfig } from '../utils/Notify';
import { handleFidelityCardError } from '../utils/WsUtils';

export const addFidCard =
  (
    axiosInstance,
    userInfo,
    order,
    fidCardNum,
    storeId,
    onSuccess,
    setLoading,
    companyId,
  ) =>
  async (dispatch, getState) => {
    dispatch({ type: MODIFY_USER_REQUEST });
    console.info('addFidCard', userInfo, order, fidCardNum, storeId);

    axiosInstance
      .post('/user/add-fidelity-card', {
        userInfo,
        ...(order && { order }),
        fidCardNum,
        storeId,
        companyId,
      })
      .then(({ data }) => {
        onSuccess(data);
        dispatch({ type: MODIFY_USER_SUCCESS, payload: data });
        localStorage.setItem('user', JSON.stringify(getState().user));
      })
      .catch((error) => {
        dispatch({ type: MODIFY_USER_FAIL });
        console.error('Add card failed', error);

        const errorConfig = handleFidelityCardError(error);
        notifyFromErrorConfig(errorConfig);

        if (typeof setLoading === 'function') {
          setLoading(false);
        }
      });
  };
